import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SpaceRemoverInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to modify it
    const clonedRequest = req.clone({
      body: this.trimPayloadSpaces(req.body),
    });

    // Pass the cloned request instead of the original request to the next handler
    return next.handle(clonedRequest);
  }

  private trimPayloadSpaces(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    // Recursively trim spaces from string properties in payload
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (typeof obj[prop] === 'string') {
          obj[prop] = obj[prop].trim();
        } else if (typeof obj[prop] === 'object') {
          obj[prop] = this.trimPayloadSpaces(obj[prop]);
        }
      }
    }

    return obj;
  }
}
